import { getUrlParam } from "../../lib/helper";
import { Paper, Stack, Typography } from "@mui/material";
import { Bar } from "react-chartjs-2";
import { blue_chart_color } from "../../lib/theme";

export default function ProductPromotionalPresenceBar(props: {
  title: string;
  data: { label: string; value: number }[];
}) {
  const mobile = getUrlParam("mobile");
  const { title, data } = props;
  const labels = (data || []).map((d) => d.label);
  const values: number[] = (data || []).map((d) => d.value);

  return (
    <Stack spacing={2}>
      <Paper elevation={mobile ? 0 : 2} className="padding-small">
        <Typography variant={"h6"} textAlign={"center"}>
          {title}
        </Typography>
      </Paper>
      <Paper elevation={mobile ? 0 : 2} className="padding-normal">
        <Bar
          plugins={[
            {
              id: "overBar",
              afterDatasetsDraw: (context) => {
                var ctx = context.ctx;
                context.data.datasets.forEach(function (dataset) {
                  const meta = context.getDatasetMeta(0);
                  meta.data.forEach((item, i) => {
                    const data = dataset.data[i]
                      ? `${((dataset.data[i] as number) * 100).toFixed(0)}%`
                      : "";
                    ctx.textAlign = "center";
                    ctx.textBaseline = "middle";
                    ctx.fillStyle = "grey";
                    ctx.save();
                    ctx.translate(item.x, item.y - 10);
                    ctx.fillText(data, 0, 0);
                    ctx.restore();
                  });
                });
              },
            },
          ]}
          options={{
            plugins: {
              legend: { display: false },
            },
            scales: {
              x: {
                grid: { display: false },
              },
              y: {
                grid: { display: false },
                ticks: {
                  format: {
                    style: "percent",
                  },
                },
                max: 1,
              },
            },
          }}
          data={{
            labels: labels,
            datasets: [
              {
                data: values,
                backgroundColor: blue_chart_color,
                borderRadius: 5,
              },
            ],
          }}
        />
      </Paper>
    </Stack>
  );
}
